<script lang="ts">
  import { modalContent, modalIsOpened, textDir } from "$stores";
  import type { BlogListItemStoryblok } from "$types/components";
  import { storyblokEditable } from "@storyblok/svelte";
  import Image from "$lib/atoms/Image.svelte";
  import Button from "$lib/atoms/Button.svelte";
  import { ButtonColor, IconType } from "$types/atoms";

  export let blok: BlogListItemStoryblok;

  let hasModal = (blok?.modal?.length ?? 0) > 0;
  let isNewTab = (blok?.link?.linktype ?? "") !== "story" && !hasModal;

  function makeUrl(blok: BlogListItemStoryblok) {
    const url = blok.link?.story?.url ?? blok.link?.cached_url;
    if (url[0] === "/" || url.includes("://")) return url;
    return "/" + url;
  }
</script>

<a
  on:click={(e) => {
    if (hasModal && blok.modal && blok.modal[0]) {
      e.preventDefault();
      $modalContent = blok.modal[0];
      $modalIsOpened = true;
      return false;
    }
  }}
  class="blog-list-item"
  href={hasModal ? "#" : makeUrl(blok)}
  target={isNewTab ? "_blank" : ""}
  use:storyblokEditable={blok}
  rel="noreferrer"
>
  <div class="thumbnail">
    <div class="thumbnail-inner">
      {#if blok.thumbnail}
        <Image
          aspect={"3-2"}
          class="thumbnail-image"
          lgSize="30"
          media={blok.thumbnail}
          rounded={false}
          roundedMd={true}
          smSize="100"
        />
      {/if}
    </div>

    <div class="cta mobile">
      <Button
        class="button"
        color={ButtonColor.RED}
        icon={IconType.ARROW_LINK}
        reduced
        label={blok.linkText}
      />
    </div>
  </div>

  <div class="content" dir={$textDir}>
    <p class="eyebrow type:section-title">{blok.eyebrow}</p>
    <p class="eyebrow type:h4">{blok.headline}</p>
    <div class="cta desktop">
      <Button
        color={ButtonColor.GRAY}
        icon={IconType.ARROW_LINK}
        reduced
        label={blok.linkText}
      />
      <p class="type:section-title">{blok.linkText}</p>
    </div>
  </div>
</a>

<style lang="scss">
  .blog-list-item {
    background: rgb(var(--color-warm-grey));
    text-decoration: none;
    color: currentColor;
    overflow: hidden;
    border-radius: 6px;
    display: block;
    transition: background 0.3s;

    @include breakpoint("small") {
      display: flex;
      align-items: center;
      //margin-left: calc(var(--grid-gutter) * -1 / 2);
      //margin-right: calc(var(--grid-gutter) * -1 / 2);
      padding: 12px 12px 12px 0;
    }

    &:hover {
      background: rgb(var(--color-grey-hover));

      :global(.button) {
        background: rgb(var(--color-red-secondary));
      }

      :global(.button svg) {
        color: rgb(var(--color-white));
      }

      :global(.thumbnail-image img) {
        transform: scale(1.08);
      }
    }
  }

  .thumbnail {
    width: 100%;
    position: relative;

    @include breakpoint("small") {
      width: calc((100%) / 12 * 4);
      padding: 0 calc(var(--grid-gutter) / 2);
      padding-left: 12px;
    }

    .thumbnail-inner {
      position: relative;
      height: 100%;
      width: 100%;
      overflow: hidden;
    }

    :global(.thumbnail-image img) {
      transition: transform 0.6s;
    }
  }

  .content {
    width: 100%;
    padding: 16px 16px 40px;

    @include breakpoint("small") {
      width: calc((100%) / 12 * 6 + 6px);
      padding: 0 calc(var(--grid-gutter) / 2);
      margin-left: calc((100% / 12) + 3px);
      aspect-ratio: auto;
    }

    .eyebrow {
      margin-bottom: fluid(12px, 12px);
    }
  }

  .cta {
    &.mobile {
      display: block;
      position: absolute;
      bottom: 16px;
      left: 16px;
      z-index: 6;

      @include breakpoint("small") {
        display: none;
      }
    }

    &.desktop {
      display: none;

      @include breakpoint("small") {
        display: flex;
        align-items: center;
        column-gap: fluid(16px, 16px);
        margin-top: fluid(24px, 24px);
      }
    }
  }
</style>
